import React from 'react';
import { Navigate } from 'react-router-dom';

// DashboardLayout captures the invitation and opens its dialog above the dashboard.
export default function WorkspaceInvitationPage() {
  return <Navigate to="/dashboard" replace />;
}
